<template>
  <div class="HuangMu">
    <!-- 夏、秋、冬 -->
    <div class="winter" v-if="(nowMoth >= 6 && nowMoth <= 12) || (nowMoth >= 1 && nowMoth <= 2)">
      <div class="banner">
        <img width="100%" src="../../../assets/img/HuangMu/HuangMu_Banner_sumAndautAandWin.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HuangMu/HuangMu_lianbai_sumAndautAandWin.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HuangMu/sumAndautAandWin_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>包包菜又名包菜，学名莲花白，是一种脆甜美味的蔬菜。</p>
            <p>近年来，皇木镇依托高山低温气候、优质土壤等资源，大力调整农业产业结构，鼓励群众发展高山包包菜种植，目前种植面积超过1万亩,年产量超过1亿斤。皇木包包菜自然生长、品质达到生态标准，味道鲜美、脆甜可口，长期供应成都周边市场，并逐步拓展川内外及国内外市场。</p>
            <p>目前，皇木首季包包菜已完成销售，产量达3000万公斤，创造了3500万元的稳定收入。</p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HuangMu/HuangMu_jianjiePic_sumAndautAandWin.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HuangMu/sumAndautAandWin_square.png')" color="#82901C"
        borderBottomColor="#82901C" boxBorderColor="#D6DAC7" btnBJcolor="#BFC78E" hoverBJcolor="#869423">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HuangMu/sumAndautAandWin_square.png')" color="#82901C" borderBottomColor="#82901C"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HuangMu/sumAndautAandWin_square.png')" color="#82901C"
        borderBottomColor="#82901C" boxBorderColor="#D6DAC7"></ztxzList>
    </div>    
    <!-- 四季 -->
    <div class="spring" v-else >
      <div class="banner">
        <img width="100%" src="../../../assets/img/HuangMu/HuangMu_Banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HuangMu/HuangMu_larouPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HuangMu/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>皇木腊肉，川西特产。</p>
            <p>皇木腊肉，肥肉琥珀透，瘦肉金丝红，肥中含肌，瘦中润脂，瘦肉化渣，肥肉生香，色泽艳丽，味美可口。内含丰富的蛋白质和氨基酸，多种维生素和微量元素，属发酵类肉制品。</p>
            <p>
              皇木腊肉是川西平原腊肉和横断山膘肉文化融合的产物，既保留了大西南少数民族的粗狂自然的特质，又兼顾了川西平原食不厌精的美食特质。
            </p>
            <p>
              皇木腊肉因原产皇木镇而得名，皇木镇是清嘉古道上的重镇，因地处偏僻大山，一直不为人知，导致皇木腊肉养在深山人未识，近年来，随着饕客播主的深探细挖，皇木腊肉才作为新晋川味美食被世人所熟知。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HuangMu/HuangMu_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HuangMu/square.png')" color="#751B01"
        borderBottomColor="#751B01" boxBorderColor="#D0C0BD" btnBJcolor="#B88A7D" hoverBJcolor="#751B01">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HuangMu/square.png')" color="#751B01"
        borderBottomColor="#751B01"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HuangMu/square.png')" color="#751B01"
        borderBottomColor="#751B01" boxBorderColor="#D0C0BD"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'HuangMu',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'皇木镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.HuangMu {
  background: url('../../../../src/assets/img/HuangMu/HuangMu_bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 23px;
}

.spring .top_title {
  color: #751B01;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #751B01;
  height: 12%;
}
.winter .top_title {
  color: #82901C;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #82901C;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>